import { gql } from '@apollo/client';

export const NOTIFICATION_QUERY = gql`
  query notifications(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    notifications(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      notifications {
        id
        message
        createdAt
        image
        isSeen
        isOpened
        isAdminOpened
        typeName
        trader {
          id
          firstName
          lastName
          entityName
          callingCode {
            id
            callingCode
          }
          phone
        }
      }
      totalPages
      totalCount
    }
  }
`;

export const NOTIFICATION_SUBSCRIPTION_QUERY = gql`
  subscription notifications(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    notifications(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      notifications {
        id
        message
        createdAt
        image
        isSeen
        isOpened
        isAdminOpened
        typeName
        trader {
          id
          firstName
          lastName
          entityName
          callingCode {
            id
            callingCode
          }
          phone
        }
      }
      totalPages
      totalCount
    }
  }
`;

export const SEND_CUSTOM_NOTIFICATION = gql`
  query sendCustomNotificationToTrader(
    $subject: String
    $description: String
    $osType: String
    $imageUrl: String
    $videoUrl: String
    $notificationType: NotificationType
    $scheduledAt: String
  ) {
    sendCustomNotificationToTrader(
      subject: $subject
      description: $description
      osType: $osType
      imageUrl: $imageUrl
      videoUrl: $videoUrl
      notificationType: $notificationType
      scheduledAt: $scheduledAt
    )
  }
`;

export const MARK_NOTIFICATION_READ = gql`
  mutation openAdminNotification($notificationId: ID!) {
    openAdminNotification(notificationId: $notificationId)
  }
`;
